import React from 'react';
import { Outlet } from '@tanstack/react-router';
import { useSelector } from 'react-redux';
import { Container, Loader } from 'shared-portal-component';

import LoggedInLayout from '@/layout/LoggedInLayout/LoggedInLayout';
import { selectUser } from '@/store/selectors/user';
import { selectCatalogLoading } from '@/store/selectors/sixCatalog';
import { selectSixDetailLoading } from '@/store/selectors/sixDetail';
import { selectLoadingExternal, selectLoadingInternal } from '@/store/selectors/createSix';
import UserModalContainer from '@/components/common/UserModalContainer/UserModalContainer';
import UpdatePasswordModalContainer from '@/components/common/UpdatePasswordModalContainer/UpdatePasswordModalContainer';
import '@/layout/CustomerMainLayout/CustomerMainLayout.scss';
import { getCustomerInitials } from '@/utils/format';
import { SixConfirmModalContainer } from '@/components/common/Confirm/SixConfirmModalContainer';

const CustomerMainPageLayout: React.FC = () => {
  const user = useSelector(selectUser);

  const catalogLoading = useSelector(selectCatalogLoading);
  const createLoadingInternal = useSelector(selectLoadingInternal);
  const createLoadingExternal = useSelector(selectLoadingExternal);
  const sixDetailLoading = useSelector(selectSixDetailLoading);

  const isBusy =
    catalogLoading || createLoadingInternal || createLoadingExternal || sixDetailLoading;

  const customerInitials = getCustomerInitials(user?.name ?? '')
  // Wait until user data is ready before showing layout
  if (user === null) {
    return (
      <Container fluid className="customer-layout">
        <div className="global-loader-overlay" role="alert" aria-busy="true" aria-live="polite">
          <Loader />
        </div>
      </Container>
    );
  }

  return (
    <LoggedInLayout customerName={user.name} customerInitials={customerInitials} messageCount={0}>
      {/* Global modal lives inside the layout */}
      <UserModalContainer />
      <UpdatePasswordModalContainer />
      <SixConfirmModalContainer />

      {/* Page content */}
      <Outlet />

      {/* Loader overlay inside LoggedInLayout */}
      {isBusy && (
        <div>
          <Loader />
        </div>
      )}
    </LoggedInLayout>
  );
};

export default CustomerMainPageLayout;
